module.exports = __webpack_public_path__ + "img/rCS-Lite-Plus-Repairing.69f2ffe6.jpg";